import { Component, OnInit } from "@angular/core";
import { MenuController } from "@ionic/angular";
import { AppService } from "../services/app.service";
import { HttpService } from "../services/http.service";
import { TwilioService } from "../services/twilio.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SyncService } from "../services/sync.service";
import { JsonPipe, Location } from "@angular/common";
import { AlertController } from "@ionic/angular";
import { Title } from "@angular/platform-browser";

import { Observable, ZenObservable } from "zen-observable-ts";
import { connectableObservableDescriptor } from "rxjs/internal/observable/ConnectableObservable";

import { Loader } from "@googlemaps/js-api-loader";

//twilio voice
import { Device } from "@twilio/voice-sdk";
//twilio video
import { connect, Room } from "twilio-video";
//import { ChatClient } from 'twilio-chat';
//twilio converstaion api
import {
  Client,
  State,
  Conversation,
  ConversationUpdateReason,
  Message,
  SendMediaOptions,
  Paginator,
  MessageUpdateReason,
  Participant,
  ParticipantUpdateReason,
} from "@twilio/conversations";

//https://www.twilio.com/docs/conversations/javascript/exploring-conversations-javascript-quickstart
import { Client as ConversationsClient } from "@twilio/conversations";

const translate = require("deepl");

declare var participantConnected;
declare var participantDisconnected;
//end twilio video

declare var document: any;
declare var mappedinDirectory;

@Component({
  selector: "app-support-session",
  templateUrl: "./support-session.page.html",
  styleUrls: ["./support-session.page.scss"],
})
export class SupportSessionPage implements OnInit {
  subscription: ZenObservable.Subscription;
  flags: any;
  session_id: any;
  room: any;

  client: any;
  conversationsClient: any;
  conversation: any;
  device: any;
  call: any;

  loader: any;
  map: any;
  directionsRenderer: any;
  directionsService: any;

  Video: any = require("twilio-video");

  constructor(
    public app: AppService,
    public twil: TwilioService,
    public menuCtrl: MenuController,
    private location: Location,
    public sync: SyncService,
    public http: HttpService,
    private router: Router,
    public alertController: AlertController,
    private activatedRoute: ActivatedRoute,
    public title: Title
  ) {
    this.flags = {
      modalMode: null,
      modalItem: null,
      modalStep: 1,
      miniModalMode: null,
      miniModalItem: null,

      previewURLtemp: null,
      previewURL: null,
      quickUrl: null,

      usersList: [],
      siteList: [],

      showCategories: true,
      directoryListings: [],
      searchListing: null,

      googleMaps: {
        search: { from: null, to: null, mode: "DRIVING" },
        apiKey: "AIzaSyAxu2udhNSXYJWlrGny5QKXjSaFdM6D70k",
        center: { lat: 53.5461, lng: -113.4937 },
        zoom: 13,
      },

      identity: "Support",

      twilioToken: null,
      showCustomerPreview: true,

      translationAuth: "88c887a4-7a5e-debe-a33d-3a0b171236ce:fx",
      translation: "none",

      sendTranslation: "none",
      receiveTranslation: "none",

      convoNewMessage: "",
      convoSysMessage: null,
      convoMessages: [],
      convoVideoParams: { audio: true, video: true },
      convoPauseState: 0,

      callState: "idle",

      editCategory: { id: "a" },
      categoryList: [],

      editSite: null,
      supportView: "0",
      sessionID: null,
      session: null,
      completeSession: false,
      currentSlide: 0,
      responses: [],

      appSync: null,
      increment: 0,

      site: null,
      reason: null,
      resolution: null,

      defaultSession: {
        user_id: null,
        status: "New",
        source: "agent",
        conversation: null,
        data: { url: null },
        company_id: null,
        site_id: null,
        device_id: null,
        epoch_open: null,
        epoch_mod: null,
        epoch_closed: null,
        participants: null,
        name: "New Request",
        phone: null,
        email: null,
        responses: {},
        commands: {},
        reason: "",
        notes: "",
      },
    };

    // Initializing the Google Map loader with API Key and Places Library
    this.loader = new Loader({
      apiKey: this.flags.googleMaps.apiKey,
      version: "weekly",
      libraries: ["places"],
    });
  }

  // Checking to see if a Directory exists
  directoryExists() {}

  ionViewWillEnter() {
    this.session_id = this.activatedRoute.snapshot.paramMap.get("session_id");
    this.getData();
  }

  assignUser() {
    this.flags.convoNewMessage = "Hello and welcome! Thanks for reaching out. How can I assist you today?";
    this.sendMessage(1);
    this.flags.session.user_id = this.app.sysData.userId;
    this.saveTicket(null); //save ticket
  }

  //START APP SYNC
  subscribe() {
    this.sync.GetMostRecentSync(this.session_id).then((data) => {
      console.log("inital price from app sync", data);
      this.flags.appSync = data;
      this.renderSession();
    });

    console.log("starting subscription");
    this.subscription = this.sync
      .OnUpdateSyncListener(this.session_id)
      .map((syncObject) => syncObject.value.data["onUpdateSync"])
      .subscribe(
        (data) => {
          console.log("received update via app sync", data);
          this.flags.appSync.data = data.data;
          this.renderSession();
        },
        (error) => {
          //this.app.alert('error' + error)
          console.log("logged a connection error", error);
          this.reSubscribe();
        }
      );
  }

  reSubscribe() {
    this.flags.online = false;
    console.log("subscription dead unsubscribing");
    this.unsubscribe();

    setTimeout(() => {
      console.log("retrying subscription");
      this.subscribe();
    }, 2000);
  }

  unsubscribe() {
    this.subscription.unsubscribe();
    console.log("unsubscribe");
  }

  updateSync() {
    this.flags.increment++;
    var status = this.flags.increment.toString();

    var obj = JSON.stringify(this.flags.session.data);

    this.sync
      .UpdateSync({
        id: this.session_id,
        status: status,
        data: obj,
        responses: "null",
        commands: "singleSession",
        settings: "null",
      })
      .then((data) => {
        console.log("Sync updated", data);
        //this.flags.appSync = data;
      });
  }

  // updateRequest() {
  //   var obj = {conversation_sid: this.flags.session.conversation_sid};

  //   this.http.apiPut('sessions/id/' + this.session_id, { data: obj }, null).then(data => {
  //     console.log('samsga22 ' + data);
  //     this.app.toast(' Successully Updated', 'success');
  //     //this.viewPage(1);
  //   });
  // }

  // closeRequest() {
  //   var obj = JSON.parse(JSON.stringify(this.flags.session.data));
  //   obj.status = 'Closed';
  //   obj.epoch_closed = Date.now();
  //   obj.data = JSON.stringify(obj.data)
  //   obj.user_id = this.app.sysData.userId; //assign user on close

  //   delete obj.id;
  //   delete obj.supportUrl;
  //   delete obj.url;

  //   console.log(obj);

  //   this.http.apiPut('sessions/id/' + this.session_id, { data: obj }, null).then(data => {
  //     console.log('samsga22 ' + data);
  //     this.app.toast(' Successully Updated', 'success');
  //     this.viewPage(1);
  //   });

  //   // this.sync.UpdateSync({ id: this.session_id, status: status, data: obj, responses: 'null', commands: 'session', settings: 'null' }).then(data => {
  //   //     console.log('Sync updated', data);
  //   //     //this.flags.appSync = data;
  //   // });
  // }

  editCategory(m, id) {
    //done

    if (m == 1) {
      this.flags.editCategory = { id: id };
    }
    if (m == 1.1) {
      //if editing existing category

      var obj = this.flags.categoryList.find((el) => el.id === id);
      obj = JSON.parse(JSON.stringify(obj));
      obj.entries = JSON.parse(obj.entries);
      this.flags.editCategory = JSON.parse(JSON.stringify(obj));
    }
  }
  //END APP SYNC

  saveTicket(m) {
    var obj = JSON.parse(JSON.stringify(this.flags.session));
    obj.data = JSON.stringify(obj.data);

    //save participants
    if (obj.participants) {
      obj.participants = JSON.stringify(obj.participants);
    } //save participants

    // delete obj.id;
    // delete obj.supportUrl;
    // delete obj.url;

    console.log("SAVING TICKET ", obj);
    this.http.apiPut("sessions/id/" + obj.id, { data: obj }, null).then((data) => {
      console.log("samsga22 " + data);
      this.app.toast(" Successully Updated", "success");
      this.app.updateFeed(); //update the ticket feed
      if (m == 1) {
        this.viewPage(1);
      }
    });
  }

  closeSession2() {
    var sid = this.flags.session.id;
    this.app.load("Closing", 1000);
    var obj = {
      sid: sid,
      source_type: "agent",
    };

    this.http.post("https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/close/" + sid, obj).then((data) => {
      console.log(data);
      this.app.toast("ran close", "success");
    });
  }

  closeSession() {
    var color = this.flags.editSite.settings.bgColor;
    color = color.replace("#", "");
    this.flags.surveyTarget =
      "https://wecare.helloarii.com/assets/api-survey.html?token=" +
      this.flags.session.source +
      "&id=" +
      this.flags.session.id +
      "&image=" +
      this.flags.editSite.settings.surveyImg +
      "&bgimage=" +
      this.flags.editSite.settings.bgImage +
      "&bgcolor=" +
      color;

    var sid = this.flags.session.id;
    this.app.load("Closing", 1000);
    var obj = {
      sid: this.flags.session.id,
      source_type: "Client",
      company_id: this.flags.editSite.company_id,
      url: this.flags.surveyTarget,
    };
    this.flags.convoSysMessage =
      "Thank you for chatting with me today! I'm now closing our chat session, but don't hesitate to reach out again if you have any more questions or need further assistance. Just click the chat button again whenever you're ready. Have a great day!";
    this.sendMessage(2);

    this.http.post("https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/close/" + sid, obj).then((data) => {
      console.log(data);
      this.flags.appSync.data.status = "pending";
      //this.flags.appSync.data.status = 'closed';
      //this.app.toast('ran close', 'success');

      //this.navCtrl.navigateRoot('/e/'+this.token);
    });
  }

  closeTicket() {
    //this.repoButton('survey', null);
    // this.flags.convoSysMessage = 'Ticket has been closed';
    // this.sendMessage(2);
    this.http
      .get(
        "https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/twilio/deleteConversation/?sid=" +
          this.conversation.sid
      )
      .then((data) => {
        console.log("CLOSED CONVERSATION", data);
        this.app.toast(" Successully Closed Communication", "success");
        //this.closeSession();
        this.closeTicket2();
      });
  }

  closeTicket2() {
    var obj = JSON.parse(JSON.stringify(this.flags.session));
    obj.data = JSON.stringify(obj.data);
    obj.status = "closed";
    obj.epoch_closed = Date.now();
    obj.user_id = this.app.sysData.userId;

    //save chat record
    if (obj.participants) {
      obj.participants = JSON.stringify(obj.participants);
    } //save participants

    var convo = this.flags.convoMessages.map((item) => {
      return { state: item.state };
    });
    obj.conversation = JSON.stringify(convo);

    this.http.apiPut("sessions/id/" + obj.id, { data: obj }, null).then((data) => {
      console.log("samsga22 " + data);
      this.app.updateFeed(); //update the ticket feed
      this.updateSync();

      this.viewPage(1);
    });
  }

  renderSession() {
    this.flags.appSync.data = JSON.parse(this.flags.appSync.data);
    this.flags.appSync.data.data = JSON.parse(this.flags.appSync.data.data);

    if (this.flags.appSync.data.status == "closed" || this.flags.appSync.data.status == "pending") {
      this.flags.session.status = this.flags.appSync.data.status; //update status
      this.flags.session.rating = this.flags.appSync.data.rating; //update rating
      this.flags.session.feedback = this.flags.appSync.data.feedback; //update feedback
    }

    console.log("rendered data", this.flags.appSync);
  }

  getUsers() {
    this.http
      .apiGet(
        "user_access/company_id/" +
          this.app.sysData.company_id +
          "?join=user_accounts,cid,cid,id:first_name:last_name:email",
        {}
      )
      .then((data) => {
        console.log("user list", data);
        this.flags.usersList = data.data;
      });
  }

  //START GOOGLE MAPS

  // searchMaps() {
  //   this.loader.load().then(() => {

  //   });
  //   //this.flags.googleMaps.search.from
  // }

  startMaps() {
    setTimeout(() => {
      this.gMapsInit();
    }, 500);
  }

  gMapsInit() {
    //SET DEFAULT DESTINATION VALUE AS THE MALL
    if (this.flags.editSite.place_id) {
      this.flags.googleMaps.search.to = this.flags.editSite.place_id;

      var inputTo = document.getElementById("to") as HTMLInputElement;
      inputTo.value = this.flags.editSite.address;
    }

    //START LOADING
    this.loader.load().then(() => {
      // For Autocomplete Places & Nearby Search
      const inputFrom = document.getElementById("from") as HTMLInputElement;
      const fromSearchBox = new google.maps.places.SearchBox(inputFrom);

      const inputTo = document.getElementById("to") as HTMLInputElement;
      const toSearchBox = new google.maps.places.SearchBox(inputTo);

      //STARTING MAP POSITION
      var map = new google.maps.Map(document.getElementById("googleMap") as HTMLElement, {
        center: this.flags.googleMaps.center,
        zoom: this.flags.googleMaps.zoom,
        scrollwheel: false,
      });

      // Initializing Google Maps Markers and From and To Place ID variables
      let markers: google.maps.Marker[] = [];

      //set starting marker
      markers.push(
        new google.maps.Marker({
          map,
          title: this.flags.editSite.name,
          position: this.flags.googleMaps.center,
        })
      );

      // Bias the SearchBox results towards current map's viewport.
      map.addListener("bounds_changed", () => {
        fromSearchBox.setBounds(map.getBounds() as google.maps.LatLngBounds);
        toSearchBox.setBounds(map.getBounds() as google.maps.LatLngBounds);
      });

      /*
        Places API - From Input Field
        Based on input in From searchbox, it provides Address Autocomplete and allows
        for Nearby Places search
      */
      fromSearchBox.addListener("places_changed", () => {
        const places = fromSearchBox.getPlaces()!;

        if (places.length == 0) {
          return;
        }

        // Clear out the old markers.
        markers.forEach((marker) => {
          marker.setMap(null);
        });
        markers = [];

        // For each place, get the icon, name and location.
        const bounds = new google.maps.LatLngBounds();

        places.forEach((place: any) => {
          if (!place.geometry || !place.geometry.location) {
            console.log("Returned place contains no geometry");
            return;
          }

          // Create a marker for each place.
          markers.push(
            new google.maps.Marker({
              map,
              title: place.name,
              position: place.geometry.location,
            })
          );

          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }

          this.flags.googleMaps.search.from = place.place_id;
        });
        map.fitBounds(bounds);
      });

      /*
        Places API - To Input Field
        Based on input in To searchbox, it provides Address Autocomplete and allows
        for Nearby Places search
      */
      toSearchBox.addListener("places_changed", () => {
        const places = toSearchBox.getPlaces()!;

        if (places.length == 0) {
          return;
        }

        // Clear out the old markers.
        markers.forEach((marker) => {
          marker.setMap(null);
        });
        markers = [];

        // For each place, get the icon, name and location.
        const bounds = new google.maps.LatLngBounds();

        places.forEach((place: any) => {
          if (!place.geometry || !place.geometry.location) {
            console.log("Returned place contains no geometry");
            return;
          }

          // Create a marker for each place.
          markers.push(
            new google.maps.Marker({
              map,
              title: place.name,
              position: place.geometry.location,
            })
          );

          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }

          //addressTo = place.place_id;
          this.flags.googleMaps.search.to = place.place_id;
        });
        map.fitBounds(bounds);
      });
    });
  }

  // gMapsResetRoute() {
  //   this.flags.googleMaps.search.from = null;
  //   this.flags.googleMaps.search.to = null;
  //   this.flags.googleMaps.search.mode = 'DRIVING';

  //   this.directionsRenderer.setMap(null);
  //   this.directionsRenderer.setPanel(null);

  //   this.map.setCenter(this.flags.googleMaps.center);
  //   this.map.setZoom(this.flags.googleMaps.zoom);
  // }

  gMapsDisplayRoute() {
    //GOOGLE MAPS API VARIABLES
    this.directionsRenderer = new google.maps.DirectionsRenderer();
    this.directionsService = new google.maps.DirectionsService();

    this.map = new google.maps.Map(document.getElementById("googleMap") as HTMLElement, {
      center: this.flags.googleMaps.center,
      zoom: this.flags.googleMaps.zoom,
      scrollwheel: false,
    });

    let directionsPanel = document.getElementById("directions") as HTMLElement;
    directionsPanel.innerHTML = "";

    //if fields are not set, return and stop execution
    if (!this.flags.googleMaps.search.from || !this.flags.googleMaps.search.to) {
      return;
    }

    //setup request
    let req = {
      origin: { placeId: this.flags.googleMaps.search.from },
      destination: { placeId: this.flags.googleMaps.search.to },
      travelMode: this.flags.googleMaps.search.mode,
    };

    //send request and get route
    this.directionsService.route(req, (res, status) => {
      if (status == "OK") {
        this.directionsRenderer.setMap(this.map);
        this.directionsRenderer.setDirections(res);
        this.directionsRenderer.setPanel(directionsPanel);
      } else {
        this.app.alert("Directions request failed due to " + status);
      }
    });
  }
  //END GOOGLE MAPS

  renderTwilioData() {
    console.log("closed convo log", this.flags.session);
    this.flags.convoMessages = JSON.parse(this.flags.session.conversation);
  }

  //twilio systems
  getTwilioToken() {
    //https://www.twilio.com/docs/video/api/rooms-resource#create-room
    var identity = "Support"; //                this.app.sysData.agent_name = data.data[0].name;
    var room = this.session_id;
    var sid = null; //obj.conversation_sid

    if (this.flags.session.conversation_sid) {
      sid = this.flags.session.conversation_sid;
    }

    this.http
      .get(
        "https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/twilio/token/?identity=" +
          identity +
          "&room=" +
          room +
          "&sid=" +
          sid
      )
      .then((data) => {
        console.log("GET CHAT/TICKET TOKEN", data);
        //this.app.alert(JSON.stringify(data));
        this.flags.twilioToken = data["token"];
        //this.twilioConnect();
        //this.videoConnect();

        //TWILIO VOICE INITIALIZATION
        //const Device = require('@twilio/voice-sdk').Device;
        //this.device = new Device(this.flags.twilioToken);
        //this.incomingCalls();

        //TWILIO CONVERSATION INITIALIZER
        this.client = new Client(this.flags.twilioToken);
        this.getConversation(data["conversationSid"]);
      });
  }

  //START CONVO

  diagDelete() {
    this.http
      .get(
        "https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/twilio/deleteConversation/?sid=" +
          this.flags.diagSid
      )
      .then((data) => {
        console.log("CLOSED CONVERSATION", data);
        this.app.toast(" Successully Closed Communication", "success");
        //this.closeTicket2();
      });
  }

  getConversation(sid) {
    //https://www.twilio.com/docs/conversations/quickstart#add-an-sms-participant-to-a-conversation
    //https://media.twiliocdn.com/sdk/js/conversations/releases/2.1.0/docs/classes/Client.html#userSubscribed
    var id = this.session_id.toString();

    //this.client.getConversationByUniqueName(id).then(data => { //get convo by unique name
    this.app.load("Loading session details", 500);
    this.client
      .getConversationBySid(sid)
      .then((data) => {
        //get convo by sid name
        this.conversation = data; //attach variable to conversation
        console.log("Convo Connected ", data);

        this.listConvParticipants();
        this.listMessages();
        this.subscribeConversation();
      })
      .catch((e) => {
        //this.app.alert('C1: error' + e);

        console.log("CLIENT FAILED ", this.client);
        console.log("NO CONVERSATION EXISTS CREATING A NEW ONE");
        this.app.alert("An error occured connecting to conversation, please try again");
        //this.newConversation();
      });
  }

  subscribeConversation() {
    //handle events in the conversation
    this.client.on(
      "conversationUpdated",
      ({ conversation, updateReasons }: { conversation: Conversation; updateReasons: ConversationUpdateReason[] }) => {
        // Fired when the attributes or the metadata of a conversation have been updated
        console.log("something updated in chat" + updateReasons, conversation);
        this.listMessages();
      }
    );
  }

  receiveTranslation(m) {
    console.log("TRANSLATION INCOMING RAN", m);

    //update all messages
    if (this.flags.receiveTranslation != "none" && m == 0) {
      for (let i = 0; i < this.flags.convoMessages.length; i++) {
        if (this.flags.convoMessages[i].state.author != "Support") {
          //if its not a message from support translate it
          var obj = this.flags.convoMessages[i].state.body;
          this.deepL(2, obj).then((str) => {
            console.log("Output: ", str);
            this.flags.convoMessages[i].state.translated = str;
          });
        }
      }
    }

    //if its a single message update
    if (this.flags.receiveTranslation != "none" && m == 1) {
      var i = +this.flags.convoMessages.length - 1;
      if (this.flags.convoMessages[i].state.author != "Support") {
        //if its not a message from support translate it
        var obj = this.flags.convoMessages[i].state.body;
        this.deepL(2, obj).then((str) => {
          console.log("Output: ", str);
          this.flags.convoMessages[i].state.translated = str;
        });
      }
    }

    //this.scrollChat();
  }

  async listMessages() {
    var limit = 1000; //initial load limit
    if (this.flags.convoMessages.length) {
      limit = 1; //subsequent limit
    }

    let messagesPaginator: Paginator<Message> = await this.conversation.getMessages(limit);
    const messages: Message[] = messagesPaginator.items;

    for (let i = 0; i < messages.length; i++) {
      if (
        limit == 1000 ||
        messages[i]["state"]["sid"] != this.flags.convoMessages[+this.flags.convoMessages.length - 1]["state"]["sid"]
      ) {
        this.flags.convoMessages.push(messages[i]);
        this.receiveTranslation(limit); //send 1 to update the last value for translation
      }
    }

    //this.scrollChat();
    //this.flags.convoMessages = messages;
    //console.log('got messages', this.flags.convoMessages);
    console.log(limit + "pull");
    console.log("got messages firect", messages);
  }

  async variableInjection(obj) {
    //swap variables
    obj = obj.replace(/{agent_name}/g, "<b>" + this.app.sysData.agent_name + "</b>"); //agent name
    obj = obj.replace(/{location_name}/g, "<b>" + this.app.sysData.agent_name + "</b>"); //mall name

    //handle translation
    if (this.flags.sendTranslation != "none") {
      //translation turned on

      //run through deep L for translation
      this.deepL(1, obj)
        .then((str) => {
          obj = obj + "\n--\n" + str + "\n\n ~" + this.app.sysData.agent_name; //put in agent name
          this.conversation.sendMessage(obj);
        })
        .catch((err) => {
          obj = obj + "\n--\n Error \n\n ~" + this.app.sysData.agent_name; //put in agent name
          this.conversation.sendMessage(obj);
        });
      //end
    } else {
      //translation turned off
      obj = obj + "\n ~" + this.app.sysData.agent_name; //put in agent name
      this.conversation.sendMessage(obj);
    }
  }

  scrollChat() {
    // setTimeout(() => {
    //   // Scroll to the element
    //   const element = document.querySelector('a[name="chatTarget"]');
    //   element.scrollIntoView({ behavior: "smooth" });
    // }, 100);
  }

  async deepL(m, str) {
    var promise = new Promise((resolve, reject) => {
      var targetLanguage = "en";
      if (m == 1) {
        targetLanguage = this.flags.sendTranslation;
      } //target for sending messages
      if (m == 2) {
        targetLanguage = this.flags.receiveTranslation;
      } //target for iterating chat

      translate({
        free_api: true,
        text: str,
        target_lang: targetLanguage,
        auth_key: this.flags.translationAuth,
      })
        .then((result) => {
          console.log("Output: ", result.data);
          resolve(result.data.translations[0].text);
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        });
    });
    return promise;
  }

  async listConvParticipants() {
    let participants: Participant[] = await this.conversation.getParticipants();
    console.log("GOT PARTICIPANTS", participants);

    var arr: any = [];
    for (var i in participants) {
      arr.push({ state: participants[i]["state"] });
    }

    this.flags.session.participants = arr;
  }

  async convParticipants(m, item) {
    var participant: any = "Support";

    if (m == 0) {
      //if conversation doesnt have support located in it
      var sid = this.flags.session.id;
      this.http
        .get(
          "https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/twilio/addParticipant/?sid=" +
            sid +
            "&participant=" +
            participant
        )
        .then((data) => {
          if (data["response"] == "true") {
            this.app.toast(" Successully added Communication", "success");
          } else {
            this.app.alert("Eror occurred: " + JSON.stringify(data["response"]));
          }
          this.listConvParticipants(); //get refreshed list
        });
    }

    //ADD PHONE PARTICIPANT
    if (m == 1 && this.flags.session.phone.length >= 11) {
      var sid = this.conversation.sid;
      participant = this.flags.session.phone;
      this.http
        .get(
          "https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/twilio/addSMSParticipant/?sid=" +
            sid +
            "&participant=" +
            participant
        )
        .then((data) => {
          console.log("ADD PARTICIPANT", data);

          if (data["response"] == "true") {
            this.app.toast(" Successully added Communication", "success");
            this.flags.convoSysMessage = participant + " has been added to ticket " + this.flags.session.id;
            this.sendMessage(2);
          } else {
            this.app.alert("Error occurred: " + JSON.stringify(data["response"]));
          }

          this.listConvParticipants(); //get refreshed list
        })
        .catch((err) => {
          console.log(err);
          this.app.alert("ep1: An error occurred please try again later or contact administrator");
        });
    } else if (m == 1 && this.flags.session.phone.length < 11) {
      this.app.alert("please enter a valid phone number with area code and country code");
    }

    //ADD WHATS APP PARTICIPANT
    if (m == 1.3 && this.flags.session.phone.length >= 11) {
      var sid = this.conversation.sid;
      participant = this.flags.session.phone;
      this.http
        .get(
          "https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/twilio/addWAParticipant/?sid=" +
            sid +
            "&participant=" +
            participant
        )
        .then((data) => {
          console.log("ADD PARTICIPANT WHATS APP", data);

          if (data["response"] == "true") {
            this.app.toast(" Successully added Communication", "success");
            this.flags.convoSysMessage = participant + " has been added to ticket " + this.flags.session.id;
            this.sendMessage(2);
          } else {
            this.app.alert("Error occurred: " + JSON.stringify(data["response"]));
          }

          this.listConvParticipants(); //get refreshed list
        })
        .catch((err) => {
          console.log(err);
          this.app.alert("ep1: An error occurred please try again later or contact administrator");
        });
    } else if (m == 1 && this.flags.session.phone.length < 11) {
      this.app.alert("please enter a valid phone number with area code and country code");
    }

    //REMOVE PARTICIPANT FORM TICKET
    if (m == 1.1) {
      var sid = this.conversation.sid;
      participant = item.state.sid;
      this.http
        .get(
          "https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/twilio/remParticipant/?sid=" +
            sid +
            "&participant=" +
            participant
        )
        .then((data) => {
          console.log("REMOVE PARTICIPANT", data);

          if (data["response"] == "true") {
            this.app.toast(" Successully added Communication", "success");
            this.flags.convoSysMessage = "A participant has been removed";
            this.sendMessage(2);
          } else {
            this.app.alert("Eror occurred: " + JSON.stringify(data["response"]));
          }

          this.listConvParticipants(); //get refreshed list
        })
        .catch((err) => {
          console.log(err);
          this.app.alert("ep2: An error occurred please try again later or contact administrator");
        });
    }
  }

  // async addConvoParticipant(m) {
  //   if(m == 1) {
  //     this.conversation.add('Client');
  //   }

  //   if(m == 2) {
  //     const proxyAddress: string = "+13854690168";
  //     const address: string = "+1" + this.flags.session.phone;
  //     await this.conversation.addNonChatParticipant(proxyAddress, address).then(data => {
  //       this.flags.convoSysMessage = 'SMS: +1'+this.flags.session.phone + ' added to chat';
  //       this.sendMessage(2);
  //       this.saveTicket(null);
  //     }).catch(err => {
  //       this.app.alert('Could not add number to chat: ' + err);
  //     })
  //   }
  // }

  // async addsmsConversation() {
  //   const proxyAddress: string = "+13854690168";
  //   const address: string = "+16504559111";
  //   await this.conversation.addNonChatParticipant(proxyAddress, address);
  // }

  // async addchatConversation() {
  //   this.conversation.add('Client');
  // }

  // async leaveConvo() {
  //   await this.conversation.leave();
  //   this.listConversationParticipants()
  // }

  async sendMessage(m) {
    if (this.flags.convoNewMessage && m == 1) {
      //send agent message
      var obj: any = this.flags.convoNewMessage;
      this.flags.convoNewMessage = "";
      this.variableInjection(obj);
    }

    if (this.flags.convoSysMessage && m == 2) {
      //send system message
      var obj: any = this.flags.convoSysMessage;
      this.flags.convoSysMessage = "";
      await this.conversation.sendMessage(obj);
    }
  }

  // async sendMMSMessage() {
  //   const file = await fetch("https://v.fastcdn.co/u/ed1a9b17/52533501-0-logo.svg");
  //   const fileBlob = await file.blob();

  //   // Send a media message
  //   const sendMediaOptions: SendMediaOptions = {
  //       contentType: file.headers.get("Content-Type"),
  //       filename: "twilio-logo.svg",
  //       media: fileBlob
  //   };

  //   await this.conversation.prepareMessage().addMedia(sendMediaOptions).build().send();
  // }

  //END CONVO

  //START VIDEO
  twilioConnectPreview(m) {
    if (m == 0) {
      if (this.flags.localVideoTrack) {
        this.flags.localVideoTrack.stop();
      }
      var div = document.getElementById("localVideoFeed");
      if (div) {
        div.remove();
      }
    }
    if (m == 1) {
      //show local preview
      const localVideoElement = document.getElementById("localVideo");
      const div = document.createElement("div");
      div.id = "localVideoFeed";
      div.className = "localVideo is-support-localVideo";

      this.Video.createLocalVideoTrack()
        .then((track) => {
          this.flags.localVideoTrack = track;
          div.appendChild(track.attach());
          localVideoElement.appendChild(div);
        })
        .catch((error) => {
          console.error(`Error creating local video track: ${error}`);
        });
    }
  }

  twilioConnect(m) {
    if (m == 1) {
      //if audio only
      this.flags.convoVideoParams.video = false;
      this.flags.convoVideoParams.audio = true;
      this.flags.convoPauseState = 0;
      this.flags.convoSysMessage = "Audio mode now on";
      this.twilioConnectPreview(0);
    }

    if (m == 2) {
      //if video and audio
      this.flags.convoVideoParams.video = true;
      this.flags.convoVideoParams.audio = true;
      this.flags.convoPauseState = 0;
      this.flags.convoSysMessage = "Video mode now on";
      this.twilioConnectPreview(1);
    }

    if (m == 3) {
      this.flags.convoVideoParams.video = false;
      this.flags.convoVideoParams.audio = false;
      this.flags.convoPauseState = 1;
      this.flags.convoSysMessage = "Paused audio & video";
      this.twilioConnectPreview(0);
    }

    this.Video.connect(this.flags.twilioToken, this.flags.convoVideoParams).then((room) => {
      this.room = room;
      this.sendMessage(2);

      console.log("CONNECTED TO ROOM ", room);
      room.participants.forEach(participantConnected);
      room.on("participantConnected", participantConnected);
      room.on("participantDisconnected", participantDisconnected);
      room.once("disconnected", (error) => room.participants.forEach(participantDisconnected));
    });
  }

  checkTwilioConnections() {
    console.log("CURRENTLY ACTIVE TWILIO", this.room);
  }

  stopTwilioConnect() {
    this.twilioConnectPreview(0);
    this.room.disconnect();
    this.flags.convoSysMessage = "Video and Audio mode turned off";
    this.sendMessage(2);
  }

  videoConnect() {
    const Video = require("twilio-video");
    Video.connect(this.flags.twilioToken, { name: "room-name" }).then((room) => {
      console.log('Connected to Room "%s"', room.name);
      this.room = room;
      room.participants.forEach(participantConnected);
      room.on("participantConnected", participantConnected);

      room.on("participantDisconnected", participantDisconnected);
      room.once("disconnected", (error) => room.participants.forEach(participantDisconnected));
    });
  }

  videoDisconnect() {
    this.room.disconnect();
  }

  // twilioConnect() {
  //   if(this.flags.twilioToken) {
  //     connect(this.flags.twilioToken).then(room => {
  //       this.room = room;

  //       console.log(room);

  //       //room.once('disconnected', () => {});
  //       //room.disconnect();

  //       //this.handleConnectedParticipant(room.localParticipant);

  //     }, error => {
  //       this.app.alert('Error: ' + error);
  //     });
  //   } else {
  //     this.app.toast('No connection token', 'danger');
  //   }
  // }

  // twilioDisconnect() {
  //   this.room.once('disconnected', () => {});
  //   this.room.disconnect();
  //   this.app.alert('Disconnected');
  // }

  //https://www.twilio.com/docs/video/tutorials/user-identity-access-tokens#access-token-server-sample-applications
  // JSconnect() {
  //   const { connect } = require('twilio-video');

  //   connect('$TOKEN', { name:'my-new-room' }).then(room => {
  //     console.log(`Successfully joined a Room: ${room}`);
  //     room.on('participantConnected', participant => {
  //       console.log(`A remote Participant connected: ${participant}`);
  //     });
  //   }, error => {
  //     console.error(`Unable to connect to Room: ${error.message}`);
  //   });
  // }
  //END TWILIO SYSTEMS

  contactButton(item) {
    this.app.toast("Contact link sent", "success");
    var target =
      "https://wecare.helloarii.com/assets/api-contact.html?name=" +
      item.name +
      "&contact=" +
      item.contact +
      "&type=video";
    this.flags.session.data.supportUrl = target;
    this.flags.session.data.url = target;
    this.updateSync();
  }

  closeModal() {
    this.flags.modalMode = null;
  }

  previewWindow(url) {
    //window.open(this.flags.previewURLtemp, "Ratting","width=800,height=600,left=150,top=200,toolbar=0,status=0,");
    //window.open(this.flags.previewURLtemp, "_parent");

    if (url) {
      window.open(url, "Ratting", "width=800,height=600,left=150,top=200,toolbar=0,status=0,");
    } else {
      window.open(this.flags.previewURLtemp, "Ratting", "width=800,height=600,left=150,top=200,toolbar=0,status=0,");
    }

    //window.open( this.flags.previewURLtemp,'popUpWindow','height=700,width=800,left=10,top=10,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no,status=yes');
  }

  openModal(m, item) {
    this.flags.modalMode = m;

    //REPOS
    if (m == "website") {
      this.flags.modalItem = JSON.parse(JSON.stringify(item));
      this.flags.previewURLtemp = item.target;
      this.flags.previewURL = item.target;
      this.flags.modalMode = "preview";
    }

    if (m == "external") {
      // this.flags.modalItem = JSON.parse(JSON.stringify(item));
      // this.flags.previewURLtemp = item.target;
      // this.flags.previewURL = item.target;
      // this.flags.modalMode = 'preview';

      window.open(item.target, "_blank");
    }

    if (m == "qr") {
      this.flags.modalItem = JSON.parse(JSON.stringify(item));
      var target = "https://wecare.helloarii.com/assets/api-qr.html?src=" + item.target;
      this.flags.previewURLtemp = target;
      this.flags.previewURL = target;
      this.flags.modalMode = "preview";
      //this.app.alert('qr');
    }

    if (m == "image") {
      this.flags.modalItem = JSON.parse(JSON.stringify(item));
      var target = "https://wecare.helloarii.com/assets/api-image.html?src=" + item.target + "&type=image";
      this.flags.previewURLtemp = target;
      this.flags.previewURL = target;
      this.flags.modalMode = "preview";
    }

    if (m == "video") {
      this.flags.modalItem = JSON.parse(JSON.stringify(item));
      var target = "https://wecare.helloarii.com/assets/api-video.html?src=" + item.target + "&type=video";
      this.flags.previewURLtemp = target;
      this.flags.previewURL = target;
      this.flags.modalMode = "preview";
    }

    if (m == "text") {
      this.flags.modalItem = JSON.parse(JSON.stringify(item));
      var target = "https://wecare.helloarii.com/assets/api-text.html?src=" + item.target;
      this.flags.previewURLtemp = target;
      this.flags.previewURL = target;
      this.flags.modalMode = "preview";
    }

    if (m == "pdf") {
      this.flags.modalItem = JSON.parse(JSON.stringify(item));
      var target = "https://wecare.helloarii.com/assets/api-pdf.html?src=" + item.target;
      this.flags.previewURLtemp = target;
      this.flags.previewURL = target;
      this.flags.modalMode = "preview";
    }
    //END REPOS

    //PREVIEW CUSTOM DISPLAY
    if (m == "previewCX") {
      this.flags.modalItem = item;
      this.flags.previewURLtemp = this.flags.session.data.supportUrl;
      this.flags.previewURL = this.flags.session.data.supportUrl;
    }

    //CONTACTS
    if (m == "contact") {
      this.flags.modalItem = JSON.parse(JSON.stringify(item));
      this.flags.modalItem.flags = {
        name: true,
        title: true,
        phone: true,
        mobile: true,
        email: true,
        address: true,
        website: true,
        notes: true,
      };
    }
  }

  phoneButton(m, item) {
    var dial = "";

    if (m == "contact") {
      dial = item;
      this.twil.flags.phoneOverlay = true;
      this.twil.dialer("dall");
      this.twil.dialer(dial);
    }
  }

  emailButton(m, item) {
    if (m == "mailto") {
      window.location.href = "mailto:" + item + "?subject=Communication%20From%20Arii&body=";
    }
  }

  chatButton(m, item) {
    var message = "";
    this.flags.activeModule = 1;

    if (m == "website") {
      //message += '<a href="'+item.target+'" target="_blank">' + item.target + '</a>';
      message = "Shared a website: " + item.target;
    }

    if (m == "external") {
      message += 'Shared an external link: <a href="' + item.target + '" target="_blank">' + item.name + "</a>";
      // message = "Shared an external link: " + item.target;
    }

    if (m == "qr") {
      //var target = '<a href="https://wecare.helloarii.com/assets/api-qr.html?src='+item.target+'" target="_blank">' + item.target + '</a>';
      var target = "Shared: https://wecare.helloarii.com/assets/api-qr.html?src=" + item.target;
      message += target;
    }

    if (m == "image") {
      //var target = '<a href="https://wecare.helloarii.com/assets/api-image.html?src='+item.target+'" target="_blank">' + item.target + '</a>';
      var target = "Shared an image: https://wecare.helloarii.com/assets/api-image.html?src=" + item.target;
      message += target;
    }

    if (m == "video") {
      //var target = '<a href="https://wecare.helloarii.com/assets/api-video.html?src='+item.target+'" target="_blank">' + item.target + '</a>';
      var target = "Shared a video: https://wecare.helloarii.com/assets/api-video.html?src=" + item.target;
      message += target;
    }

    if (m == "pdf") {
      //var target = '<a href="https://wecare.helloarii.com/assets/api-pdf.html?src='+item.target+'" target="_blank">' + item.target + '</a>';
      var target = "Shared a PDF: https://wecare.helloarii.com/assets/api-pdf.html?src=" + item.target;
      message += target;
    }

    if (m == "text") {
      message += item.target;
    }

    if (m == "googleMap") {
      var from = this.flags.googleMaps.search.from;
      var to = this.flags.googleMaps.search.to;
      var mode = this.flags.googleMaps.search.mode;
      var zoom = this.flags.googleMaps.zoom;

      //var target = '<a href="https://wecare.helloarii.com/assets/api-googlemaps.html?from=' + from + '&to=' + to + '&mode=' + mode+ '&zoom=' + zoom +'" target="_blank">' + from + ' - '  + to + '</a>';
      var target =
        "Shared Directions: " +
        "https://wecare.helloarii.com/assets/api-googlemaps.html?from=" +
        from +
        "&to=" +
        to +
        "&mode=" +
        mode +
        "&zoom=" +
        zoom;

      //var target = 'https://arii.kastommedia.com/assets/api-googlemaps.html?from=' + from + '&to=' + to + '&mode=' + mode+ '&zoom=' + zoom;
      message += target;
      //var directions = document.getElementById("directions") as HTMLElement;
      //message += directions.innerText;
    }

    if (m == "contact") {
      if (item.name) {
        message += item.name + "\n";
      }
      if (item.title) {
        message += "Title: " + item.title + "\n";
      }
      if (item.phone) {
        message += "Ph: " + item.phone + "\n";
      }
      if (item.mobile) {
        message += "Mobile: " + item.mobile + "\n";
      }
      if (item.email) {
        message += "Email: " + item.email + "\n";
      }
      if (item.address) {
        message += "Address: \n" + item.address + "\n";
      }
      if (item.website) {
        message += "Website: " + item.website + "\n";
      }
      if (item.notes) {
        message += "Notes: \n" + item.notes + "\n";
      }
    }

    if (m == "contactModal") {
      if (item.flags.name && item.name) {
        message += item.name + "\n";
      }
      if (item.flags.title && item.title) {
        message += "Title: " + item.title + "\n";
      }
      if (item.flags.phone && item.phone) {
        message += "Ph: " + item.phone + "\n";
      }
      if (item.flags.mobile && item.mobile) {
        message += "Mobile: " + item.mobile + "\n";
      }
      if (item.flags.email && item.email) {
        message += "Email: " + item.email + "\n";
      }
      if (item.flags.address && item.address) {
        message += "Address: \n" + item.address + "\n";
      }
      if (item.flags.website && item.website) {
        message += "Website: " + item.website + "\n";
      }
      if (item.flags.notes && item.notes) {
        message += "Notes: \n" + item.notes + "\n";
      }
    }

    if (m == "directoryListing") {
      message += item.name + "\n";
      // message += item.description + '\n \n';
      if (item.phone && item.phone.number) {
        message += "PH: " + item.phone.number + "\n";
      }
      if (item.social && item.social.website) {
        message += "WEB: " + item.social.website + "\n";
      }

      for (var i in item.operationHours) {
        message += "\n Opens: " + item.operationHours[i].opens + " to " + item.operationHours[i].closes + " on: \n";

        for (var d in item.operationHours[i].dayOfWeek) {
          message += item.operationHours[i].dayOfWeek[d] + " ";
        }
      }
    }

    if (m == "directoryListingManual") {
      message += item.name + "\n";

      if (item.phone) {
        message += "PH: " + item.phone + "\n";
      }
      if (item.mobile) {
        message += "Mobile: " + item.mobile + "\n";
      }
      if (item.email) {
        message += "Email: " + item.email + "\n";
      }

      if (item.floor) {
        message += "Floor: " + item.floor + "\n";
      }
      if (item.room) {
        message += "Room: " + item.room + "\n";
      }
      if (item.address) {
        message += "Address: " + item.address + "\n";
      }
      if (item.website) {
        message += "Website: " + item.website + "\n";
      }
    }
    this.flags.convoNewMessage = message;
  }

  repoButton(m, item) {
    this.flags.activeModule = 1;
    var target: any = null;
    var name = "";

    if (m == "website") {
      this.app.toast("Link sent", "success");
      target = item.target;
      name = item.name;
      this.flags.session.data.supportUrl = target;
      this.flags.session.data.url = target;
      this.updateSync();
    }

    if (m == "external") {
      this.app.toast("Link sent", "success");
      target = item.target;
      name = item.name;
      this.flags.session.data.supportUrl = target;
      this.flags.session.data.url = target;
      this.updateSync();
    }

    if (m == "qr") {
      this.app.toast("QR Link sent", "success");
      target = "https://wecare.helloarii.com/assets/api-qr.html?src=" + item.target;
      name = item.name;
      this.flags.session.data.supportUrl = target;
      this.flags.session.data.url = target;
      this.updateSync();
      //this.app.alert('qr');
    }

    if (m == "image") {
      this.app.toast("Image link sent", "success");
      target = "https://wecare.helloarii.com/assets/api-image.html?src=" + item.target + "&type=image";
      name = item.name;
      this.flags.session.data.supportUrl = target;
      this.flags.session.data.url = target;
      this.updateSync();
    }

    if (m == "video") {
      this.app.toast("Image link sent", "success");
      target = "https://wecare.helloarii.com/assets/api-video.html?src=" + item.target + "&name=" + item.name;
      name = item.name;
      this.flags.session.data.supportUrl = target;
      this.flags.session.data.url = target;
      this.updateSync();
    }

    if (m == "pdf") {
      this.app.toast("PDF link sent", "success");
      target = "https://wecare.helloarii.com/assets/api-pdf.html?src=" + item.target;
      name = item.name;
      this.flags.session.data.supportUrl = target;
      this.flags.session.data.url = target;
      this.updateSync();
    }

    if (m == "text") {
      var message = encodeURIComponent(item.target);
      target = "https://wecare.helloarii.com/assets/api-text.html?src=" + message;
      name = item.name;
      this.flags.session.data.supportUrl = target;
      this.flags.session.data.url = target;
      this.updateSync();
    }

    //send contact details
    if (m == "contact") {
      this.app.toast("contact link sent", "success");
      var params = "?";
      if (item.name) {
        params += "&name=" + encodeURIComponent(item.name);
      }
      if (item.title) {
        params += "&title=" + encodeURIComponent(item.title);
      }
      if (item.phone) {
        params += "&phone=" + encodeURIComponent(item.phone);
      }
      if (item.mobile) {
        params += "&mobile=" + encodeURIComponent(item.mobile);
      }
      if (item.email) {
        params += "&email=" + encodeURIComponent(item.email);
      }
      if (item.address) {
        params += "&address=" + encodeURIComponent(item.address);
      }
      if (item.website) {
        params += "&website=" + encodeURIComponent(item.website);
      }
      if (item.notes) {
        params += "&notes=" + encodeURIComponent(item.notes);
      }

      target = "https://wecare.helloarii.com/assets/api-contact.html" + params;
      name = "a contact: " + item.name;
      this.flags.session.data.supportUrl = target;
      this.flags.session.data.url = target;
      console.log("CONTACT SENT " + target);
      this.updateSync();
    }

    if (m == "contactModal") {
      this.app.toast("contact edited link sent", "success");
      var params = "?";
      if (item.flags.name && item.name) {
        params += "&name=" + encodeURIComponent(item.name);
      }
      if (item.flags.title && item.title) {
        params += "&title=" + encodeURIComponent(item.title);
      }
      if (item.flags.phone && item.phone) {
        params += "&phone=" + encodeURIComponent(item.phone);
      }
      if (item.flags.mobile && item.mobile) {
        params += "&mobile=" + encodeURIComponent(item.mobile);
      }
      if (item.flags.email && item.email) {
        params += "&email=" + encodeURIComponent(item.email);
      }
      if (item.flags.address && item.address) {
        params += "&address=" + encodeURIComponent(item.address);
      }
      if (item.flags.website && item.website) {
        params += "&website=" + encodeURIComponent(item.website);
      }
      if (item.flags.notes && item.notes) {
        params += "&notes=" + encodeURIComponent(item.notes);
      }

      target = "https://wecare.helloarii.com/assets/api-contact.html" + params;
      name = "a contact: " + item.name;
      this.flags.session.data.supportUrl = target;
      this.flags.session.data.url = target;
      console.log("CONTACT SENT " + target);
      this.updateSync();
    }

    if (m == "directoryMap") {
      //SEND DIRECTORY MAP
      this.app.toast("Directory sent", "success");
      target = document.getElementById("supportDirectory").contentWindow.location.href;
      name = "a directory location";
      this.flags.session.data.supportUrl = target;
      this.flags.session.data.url = target;
      this.updateSync();
    }

    if (m == "directoryListing") {
      //SEND DIRECTORY LOCATION
      target = this.flags.editSite.directoryLink + "#/profile?location=" + item.id;
      name = "directory location: " + item.name;
      this.app.toast("Directory sent", "success");
      this.flags.session.data.supportUrl = target;
      this.flags.session.data.url = target;
      this.updateSync();
    }

    if (m == "directoryListingManual") {
      //SEND DIRECTORY LOCATION
      var params = "?";
      if (item.name) {
        params += "&name=" + encodeURIComponent(item.name);
      }
      if (item.phone) {
        params += "&phone=" + encodeURIComponent(item.phone);
      }
      if (item.mobile) {
        params += "&mobile=" + encodeURIComponent(item.mobile);
      }
      if (item.email) {
        params += "&email=" + encodeURIComponent(item.email);
      }
      if (item.floor) {
        params += "&floor=" + encodeURIComponent(item.floor);
      }
      if (item.room) {
        params += "&room=" + encodeURIComponent(item.room);
      }
      if (item.address) {
        params += "&address=" + encodeURIComponent(item.address);
      }
      if (item.website) {
        params += "&website=" + encodeURIComponent(item.website);
      }
      if (item.notes) {
        params += "&notes=" + encodeURIComponent(item.notes);
      }

      target = "https://wecare.helloarii.com/assets/api-directory.html?name=" + params;
      name = item.name;

      this.flags.session.data.supportUrl = target;
      this.flags.session.data.url = target;
      console.log("CONTACT SENT " + target);
      this.updateSync();
    }

    if (m == "googleMap") {
      var from = this.flags.googleMaps.search.from;
      var to = this.flags.googleMaps.search.to;
      var mode = this.flags.googleMaps.search.mode;
      var zoom = this.flags.googleMaps.zoom;

      target =
        "https://wecare.helloarii.com/assets/api-googlemaps.html?from=" +
        from +
        "&to=" +
        to +
        "&mode=" +
        mode +
        "&zoom=" +
        zoom;
      name = "directions";

      this.flags.session.data.supportUrl = target;
      this.flags.session.data.url = target;
      console.log("MAP SENT " + target);
      this.updateSync();
    }

    if (m == "survey") {
      const name =
        "Before you go, I'm always striving to improve my service and would greatly appreciate your feedback. It only takes a moment and really helps me serve you better. Please rate your experience and share your thoughts. Thank you for helping me enhance my service! ";

      //https://wecare.helloarii.com/assets/api-survey.html?token=demo&id=1055&image=https://arii-content.s3.us-west-2.amazonaws.com/public/4aae6f9d-20d6-4866-925e-83ce378caddf/1675794860335|supportText.png&bgimage=https://arii-content.s3.us-west-2.amazonaws.com/public/4aae6f9d-20d6-4866-925e-83ce378caddf/1677513394546|kioskBG2.png&bgcolor=e5e0e0

      //this.app.alert('token '+ this.flags.editSite.token + ' id: ' + this.flags.session.id );
      console.log("SITE: ", this.flags.editSite);
      var color = this.flags.editSite.settings.bgColor;
      color = color.replace("#", "");
      target =
        "https://wecare.helloarii.com/assets/api-survey.html?token=" +
        this.flags.session.source +
        "&id=" +
        this.flags.session.id +
        "&image=" +
        this.flags.editSite.settings.surveyImg +
        "&bgimage=" +
        this.flags.editSite.settings.bgImage +
        "&bgcolor=" +
        color;
      //target = 'https://wecare.helloarii.com/assets/api-survey.html?q=' + this.flags.session.id + '' + this.flags.session.epoch_open;

      this.flags.session.data.supportUrl = target;
      this.flags.session.data.url = target;
      console.log("SURVEY SENT " + target);
      this.updateSync();
    }

    if (target) {
      this.flags.convoSysMessage = name + target;
      this.sendMessage(2);
    }
  }

  // directoryButton(m, item) {
  //   var target;
  //   if(m == 1) { //SEND DIRECTORY MAP
  //     target = document.getElementById('supportDirectory').contentWindow.location.href;
  //     this.app.toast('Directory sent', 'success');
  //     this.flags.session.data.supportUrl = target;
  //     this.flags.session.data.url = target;
  //     this.updateSync();
  //   }

  //   if(m == 2) { //SEND DIRECTORY LOCATION
  //     target = this.flags.editSite.directoryLink+ '#/profile?location=' + item.id;
  //     this.app.toast('Directory sent', 'success');
  //     this.flags.session.data.supportUrl = target;
  //     this.flags.session.data.url = target;
  //     this.updateSync();
  //   }
  // }

  frameUrl() {
    var url = document.getElementById("iframe").contentWindow.location.href;
    this.app.alert(url);
  }

  getData() {
    this.http.apiGet("sessions/id/" + this.session_id, null).then((data) => {
      var obj = data.data[0];
      obj.data = JSON.parse(obj.data);
      if (!obj.user_id) {
        this.presentAlertConfirm(1, "No user assigned, would you like to assign yourself?", null);
      }

      this.flags.session = obj;

      console.log("get sites", obj);
      this.getSite();
      this.subscribe();
      this.getUsers();

      if (obj.status == "closed") {
        this.renderTwilioData();
      } else {
        //if(!obj.conversation_sid) { //IF NOT ASSIGNED CONVERSATION ID THEN CREATE 1
        this.getTwilioToken();
        //} else { //IF THERE IS AN ASSIGNED CONVO ID THEN LAUNCH IT
        //  this.app.alert('cid is there ' + obj.conversation_sid )
        //}
      }
    });
  }

  getSite() {
    //this.app.alert(this.flags.session.site_id);
    this.http.apiGet("company_sites/company_id/" + this.flags.session.company_id, null).then((data) => {
      console.log("get site", data.data);
      var obj = data.data;
      console.log("OBJ SITE >>>>>>>>>>>>", obj);

      for (var i in obj) {
        obj[i].settings = JSON.parse(obj[i].settings);
        obj[i].contacts = JSON.parse(obj[i].contacts);
        obj[i].directory = JSON.parse(obj[i].directory);
      }

      var site = obj.find((el) => el.id == this.flags.session.site_id);
      this.flags.siteList = JSON.parse(JSON.stringify(obj));
      this.flags.editSite = JSON.parse(JSON.stringify(site));
      console.log("SITE >>>>>>>>>>>>", this.flags.editSite.instance_settings);

      this.renderSite();
      // //set starting lat and lng
      // if(obj.lat && obj.lng) {
      //   this.flags.googleMaps.center.lat = obj.lat;
      //   this.flags.googleMaps.center.lng = obj.lng;
      // }

      // this.flags.editSite.directoryLink = 'https://arii.kastommedia.com/assets/api-mappedin.html?id='+this.flags.editSite.settings.directory.id+'&key='+this.flags.editSite.settings.directory.key;
      // this.getCategories();
      // this.getDirectoryListings();
    });
  }

  renderSite() {
    var site = this.flags.siteList.find((el) => el.id == this.flags.session.site_id);
    this.flags.editSite = JSON.parse(JSON.stringify(site));

    this.title.setTitle("Agent Session #" + this.session_id + " - " + this.flags.editSite.name);

    //set starting lat and lng
    if (this.flags.editSite.lat && this.flags.editSite.lng) {
      this.flags.googleMaps.center.lat = this.flags.editSite.lat;
      this.flags.googleMaps.center.lng = this.flags.editSite.lng;
    }

    this.flags.editSite.directoryLink =
      "https://wecare.helloarii.com/assets/api-mappedin.html?id=" +
      this.flags.editSite.settings.directory.id +
      "&key=" +
      this.flags.editSite.settings.directory.key;
    this.getCategories();
    this.getDirectoryListings();
  }

  getCategories() {
    this.http
      .apiGet("repo_categories/site_id/" + this.flags.editSite.id + "?&orderby=type+asc:priority:name", null)
      .then((data) => {
        this.flags.categoryList = data.data;
        console.log("CATEGORY List", data.data);
      });
  }

  async getDirectoryListings() {
    const params = {
      venue: this.flags.editSite.settings.directory.venue,
      clientId: this.flags.editSite.settings.directory.id,
      clientSecret: this.flags.editSite.settings.directory.key,
    };

    mappedinDirectory(params).then((data) => {
      this.flags.directoryListings = data.categories;
      console.log("SORTED CATS", data.categories);
    });
    console.log(params);
  }

  searchDirectoryListings() {
    var html = [];
    if (this.flags.searchListing) {
      var string = this.flags.searchListing;

      var regex = new RegExp(string, "i");
      for (var c in this.flags.directoryListings) {
        for (var i in this.flags.directoryListings[c].locations) {
          if (
            this.flags.directoryListings[c].locations[i].name &&
            this.flags.directoryListings[c].locations[i].name.search(regex) != -1
          ) {
            //search name
            this.flags.directoryListings[c].locations[i].categoryName = this.flags.directoryListings[c].name;

            html.push(this.flags.directoryListings[c].locations[i]);
          }
        }
      }

      // for (var i in this.flags.editSite.directory) {
      //   if (this.flags.editSite.directory[i].name && this.flags.editSite.directory[i].name.search(regex) != -1 ) { //search name
      //     this.flags.editSite.directory[i].categoryName = 'Manual'

      //     html.push(this.flags.editSite.directory[i]);
      //   }
      // }
    }
    this.flags.directoryResults = html;
  }

  searchContacts() {
    var html = [];
    if (this.flags.searchListing) {
      var string = this.flags.searchListing;

      var regex = new RegExp(string, "i");
      for (var c in this.flags.directoryListings) {
        for (var i in this.flags.directoryListings[c].locations) {
          if (
            this.flags.directoryListings[c].locations[i].name &&
            this.flags.directoryListings[c].locations[i].name.search(regex) != -1
          ) {
            //search name
            this.flags.directoryListings[c].locations[i].categoryName = this.flags.directoryListings[c].name;

            html.push(this.flags.directoryListings[c].locations[i]);
          }
        }
      }
    }
    this.flags.directoryResults = html;
  }

  viewPage(m) {
    if (m == 0) {
      //this.router.navigateByUrl('/slides-folder/' + this.folder);
      this.location.back();
    }

    if (m == 1) {
      this.router.navigateByUrl("/support");
    }
  }

  async presentAlertConfirm(m, message, params) {
    const alert = await this.alertController.create({
      header: "Message",
      message: message,
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {
            console.log("Confirm Cancel: blah");
          },
        },
        {
          text: "Okay",
          handler: () => {
            if (m == 1) {
              this.assignUser();
            }

            if (m == 1.1) {
              this.closeSession();
            }

            if (m == 1.2) {
              this.closeTicket();
            }

            if (m == 2) {
              this.convParticipants(1, null);
            }

            if (m == 2.1) {
              this.convParticipants(1.1, params);
            }

            if (m == 3) {
              this.convParticipants(1.3, null);
            }
            console.log("Confirm Okay");
          },
        },
      ],
    });

    await alert.present();
  }

  ionViewWillLeave() {
    if (this.room) {
      this.stopTwilioConnect();
    }
    this.unsubscribe();
  }

  ngOnInit() {}
}
